// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"styles__root__1_wrB","grid":"styles__grid__2hX1e"};